var React = require('react');

function DoubleChevron (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M1 0L25 0 25 24 1 24z","transform":"rotate(180 12.5 12)","key":0}),React.createElement("path",{"fill":"currentColor","d":"M17.59 12L13 16.58 8.41 12 7 13.41 13 19.41 19 13.41z","transform":"rotate(180 12.5 12)","key":1}),React.createElement("path",{"fill":"currentColor","d":"M17.59 6L13 10.58 8.41 6 7 7.41 13 13.41 19 7.41z","transform":"rotate(180 12.5 12)","key":2})]));
}

DoubleChevron.defaultProps = {"fill":"currentColor","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = DoubleChevron;

DoubleChevron.default = DoubleChevron;
